import { formatDate } from '@efdigital/ll-addon-coaching/utils/coaching-sessions/session-dates';
import MarkDown from '@efdigital/ll-addon-content/components/mark-down';
import { Heading } from '@efdigital/ll-addon-ui';
import { EmptyState } from '@efdigital/ll-xceed-v2/components/application/empty-state';
import type { CoachingCoacheeCohortAnnouncementsModel } from '@efdigital/ll-xceed-v2/routes/coaching/coachee/cohort/announcements';
import { PAGE_WRAPPER } from '@efdigital/ll-xceed-v2/utils/layout';
import type { TOC } from '@ember/component/template-only';
import { pageTitle } from 'ember-page-title';

interface AnnouncementsSignature {
  Args: {
    model: CoachingCoacheeCohortAnnouncementsModel;
    controller: unknown;
  };
}

function toDate(value: string | undefined): Date | null {
  return value ? new Date(value) : null;
}

<template>
  {{pageTitle "Announcements"}}
  <div class={{PAGE_WRAPPER}}>
    <Heading @size="lg" @text="Announcements" @class="mb-4" />

    {{#if @model.announcements.length}}
      <div class="d-flex flex-column gap-3">
        {{#each @model.announcements as |announcement|}}
          <article class="card border shadow-sm rounded-4">
            <div class="card-body p-4">
              <h2 class="h5 fw-bold mb-2">{{announcement.title}}</h2>
              {{#let (toDate announcement.startDate) as |startDate|}}
                {{#if startDate}}
                  <p class="small text-body-secondary mb-3">{{formatDate
                      startDate
                    }}</p>
                {{/if}}
              {{/let}}
              <MarkDown @markdown={{announcement.markdown}} @unsafe={{true}} />
            </div>
          </article>
        {{/each}}
      </div>
    {{else}}
      <EmptyState @message="There are no announcements right now." />
    {{/if}}
  </div>
</template> satisfies TOC<AnnouncementsSignature>;
